import {
    ADD_POLLUTION_AREA,
    EMPTY_POLLUTION_AREA,
    ADD_POLLUTION_AREA_POINT,
    CLOSE_POLLUTION_AREA,
    REMOVE_POLLUTION_AREA, SHOW_POLLUTION_AREA, HIDE_POLLUTION_AREA, CREATING_POLLUTION_AREA,
    CHANGE_POLLUTION_AREA, CHANGE_LAYER, MOVE_POLLUTION_AREA
} from '../../actions/pollutionAreas'

const initialState = {
    coordinates: [[]],
    lineStringCoordinates: [],
    isClosed: false,
    isDataStored: false,
    isCreating: false,
    polyLineObj: null,
    bbox: null,
    map: 'Barcelona',
    layers: [{layer: 'AQI', check: false}, {layer: 'NOISE', check: false}]
}

let lineStringCoordinates = [];
let polyLine;

const pollutionAreas = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_POLLUTION_AREA: {
            return {
                ...state,
                map: action.map
            }
        }


        case EMPTY_POLLUTION_AREA: {
            return {
                ...state,
                polyLineObj: action.polyLineObj
            }
        }

        case ADD_POLLUTION_AREA:

            action.coordinates[0].map((point) => lineStringCoordinates.push(point));

            if (action.admin) {
                polyLine = action.L.polyline(lineStringCoordinates).addTo(action.leafletElement);
            } else {
                polyLine = []
            }

            let types = [];

            action.types.forEach(type => {
                types.push({layer: type, check: false});
            });

            return {
                ...state,
                coordinates: action.coordinates,
                lineStringCoordinates: lineStringCoordinates,
                isClosed: true,
                isDataStored: true,
                polyLineObj: polyLine,
                bbox: action.bbox,
                layers: types
            }

        case MOVE_POLLUTION_AREA:

            if (action.error) {
                let coordinates = state.coordinates

                return {
                    ...state,
                    coordinates: coordinates
                }

            } else {
                console.log(state.polyLineObj);
                action.leafletElement.removeLayer(state.polyLineObj);

                lineStringCoordinates = [];
                action.coordinates[0].map((point) => lineStringCoordinates.push(point));

                polyLine = action.L.polyline(lineStringCoordinates).addTo(action.leafletElement);
                console.log(polyLine);

                return {
                    ...state,
                    coordinates: action.coordinates,
                    lineStringCoordinates: lineStringCoordinates,
                    bbox: action.bbox,
                    polyLineObj: polyLine
                }
            }

        case ADD_POLLUTION_AREA_POINT:
            let aux = state.coordinates[0];

            aux.push(action.polygonPoint.coordinates);

            return {
                ...state,
                coordinates: [aux],
                lineStringCoordinates: [
                    ...state.lineStringCoordinates,
                    {
                        ...action.polygonPoint.coordinates
                    }
                ],
                polyLineObj: state.polyLineObj.addLatLng(action.polygonPoint.coordinates)
            }

        case SHOW_POLLUTION_AREA:
            return {
                ...state,
                polyLineObj: state.polyLineObj.addLatLng(state.coordinates[0][0])
            }

        case CLOSE_POLLUTION_AREA:
            return {
                ...state,
                isClosed: true,
                isCreating: false,
                coordinates: [
                    ...state.coordinates,
                    {
                        ...state.coordinates[0]
                    }
                ],
                lineStringCoordinates: [
                    ...state.lineStringCoordinates,
                    {
                        ...state.lineStringCoordinates[0]
                    }
                ],
            }

        case REMOVE_POLLUTION_AREA:
            return {
                ...initialState,
                polyLineObj: state.polyLineObj.setLatLngs([])
            }

        case HIDE_POLLUTION_AREA:
            return {
                ...state,
                polyLineObj: state.polyLineObj.setLatLng([])
            }

        case CREATING_POLLUTION_AREA:
            return {
                ...state,
                isCreating: true,
            }

        case CHANGE_LAYER:
            return {
                ...state,
                layers: action.layers
            };

        default:
            return state
    }
}

export default pollutionAreas



// WEBPACK FOOTER //
// ./src/reducers/map/pollutionAreas.js